import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import styleListData from "../listData/ListTaxDeclarationData.module.css";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import { useLocation, Link } from "react-router-dom";
import { get } from "../../../adapters/xhr/api";
import MainContent from "../../../layouts/maincontent/MainContent";

const ClaimPayments = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [claimPayments, setClaimPayments] = useState([]);

  const { id, declerationId, typeId } = useParams();
  const [error, setError] = useState(null);

  const getClaimPayments = async () => {
    try {
      setIsLoading(true);
      const url = `api/declaration-system/declarations/user/claims-payment-transaction-details/${id}`;

      const response = await get(url);
      setClaimPayments(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    getClaimPayments();
  }, []);

  const data = claimPayments?.map((element) => {
    return (
      <tr key={element.id}>
        <td data-label="اسم المسدد" className="p-3">
          {element?.payer_name || "—"}
        </td>
        <td data-label="وسيلة الدفع">{element?.payment_method || "—"}</td>
        <td data-label="رقم المدفوعة">{element?.payment_number || "—"}</td>
        <td data-label="تاريخ و وقت العملية">{element?.date || "—"}</td>
        <td data-label="المبلغ المسدد">{element?.amount || "—"}</td>
        <td data-label="حالة السداد">
          <span
            style={{
              backgroundColor:
                parseInt(element?.payment_status_id) == 1
                  ? "#E6FFE6"
                  : parseInt(element?.payment_status_id) == 2
                    ? "#FFE3E3"
                    : "white",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {element?.payment_status || "—"}
          </span>
        </td>
      </tr>
    );
  });

  return (
    <>
      <MainContent>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <section className={`${styleListData.listData} `}>
            <div className="container pt-4">
              <div className={styleListData.box}>
                <div className={`${styleListData["box-header"]}`}>
                  {location?.state?.message && (
                    <div className="alert alert-danger mt-2 text-center w-25 mx-auto">
                      <h3 className="fs-5">{location?.state?.message} </h3>
                    </div>
                  )}
                  <div className="d-flex align-items-center flex-wrap mb-5">
                    <Link
                      className={`${styleListData["btn-arrow"]} ms-3`}
                      to={`${ !typeId ? `/my-debts` : 
                        (parseInt(typeId) === 1 ? `/tax-declaration/payment-under-account/list/${declerationId}` : `/payment-account-debt/list/${declerationId}`)}`}
                      state={{ activeTab: "claims" }}
                    >
                      <i className="fa-solid fa-arrow-right mt-1"></i>
                    </Link>

                    <h3
                      className="mb-0 ms-2 fw-bold"
                      style={{ color: "#005DA8" }}
                    >
                      عمليات الدفع{" "}
                    </h3>
                  </div>
                </div>
                <div
                  className={`${styleListData["table-responsive"]} table-responsive`}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col" className="h5 fw-bold">
                          اسم المسدد
                        </th>
                        <th scope="col" className="h5 fw-bold">
                          وسيلة الدفع
                        </th>
                        <th scope="col" className="h5 fw-bold">
                          رقم المدفوعة
                        </th>
                        <th scope="col" className="h5 fw-bold">
                          تاريخ و وقت العملية
                        </th>
                        <th scope="col" className="h5 fw-bold">
                          المبلغ المسدد
                        </th>
                        <th scope="col" className="h5 fw-bold">
                          حالة السداد
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length > 0 ? (
                        data
                      ) : (
                        <tr>
                          <td colSpan={6} className="h5 text-center">
                            {error}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        )}
      </MainContent>
    </>
  );
};

export default ClaimPayments;
